<template>
  <div>
    <v-select
      v-model="form.lives_with"
      :items="liveswith"
      item-text="name"
      item-value="id"
      :label="$t('PROFILE.LIVES_WITH')"
      :readonly="readonly"
      :error-messages="errors.get('lives_with')"
      append-outer-icon="mdi-close"
      @click:append-outer="clearLivesWith"
      @change="updateValue('lives_with', $event)"
    />
    <v-textarea
      v-model="form.medical_info"
      rows="2"
      :counter="1500"
      :readonly="readonly"
      :rules="getRulesByName('medical_info')"
      :error-messages="errors.get('medical_info')"
      @input="updateValue('medical_info', $event)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import formEditable from '@/modules/_global/mixins/form-editable';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { maxLength, notEmoji } from '@/modules/_global/variables/rules';

export default {
  name: 'MedicalInfoForm',

  mixins: [formEditable, i18nRefreshData],

  data() {
    return {
      form: {
        lives_with: '',
        medical_info: ''
      },
      liveswith: [],
      rules: {
        medical_info: [maxLength(1500), notEmoji]
      }
    };
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('person', ['livesWith']),

    refreshData() {
      this.livesWith().then(({ data }) => {
        this.liveswith = data.data;
      });
    },

    clearLivesWith() {
      if (!this.readonly) {
        this.form.lives_with = null;
      }
    }
  }
};
</script>
